import { recoverAgents } from './recover-agents';
import { recoverBankDetails } from './recover-bank-details';
import { recoverBusinessDocuments } from './recover-business-documents';
import { recoverBusinessInfo } from './recover-business-info';
import { recoverHeadOfficeAddress } from './recover-head-office-address';
import { recoverPointsOfSales } from './recover-points-of-sales';
import { recoverRegisteredAddress } from './recover-registered-address';

import type { PartnerApplicationResponse } from '../../model';
import type { ApplicationFormValues } from '../../model/form-values';
import { sectionNames } from '../../model/form-values';

export function mapApplicationDataResponseToFormValues(
  response: PartnerApplicationResponse
): Partial<ApplicationFormValues> {
  const businessInfo = recoverBusinessInfo(response.businessInfo);
  const registeredAddress = recoverRegisteredAddress(
    response.registeredAddress
  );
  const headOfficeAddress = recoverHeadOfficeAddress(
    response.headOfficeAddress,
    registeredAddress
  );
  const businessDocuments = recoverBusinessDocuments(
    response.businessDocuments
  );
  const bankDetails = recoverBankDetails(response.bankDetails);
  const pointsOfSales = recoverPointsOfSales(response.pointsOfSales);
  const agents = recoverAgents(response.agents);

  return {
    ...(businessInfo && { [sectionNames.businessInfo]: businessInfo }),
    ...(registeredAddress && {
      [sectionNames.registeredAddress]: registeredAddress,
    }),
    ...(headOfficeAddress && {
      [sectionNames.headOfficeAddress]: headOfficeAddress,
    }),
    ...(businessDocuments && {
      [sectionNames.businessDocuments]: businessDocuments,
    }),
    ...(bankDetails && { [sectionNames.bankDetails]: bankDetails }),
    ...(pointsOfSales && {
      [sectionNames.pointsOfSales]: pointsOfSales,
    }),
    ...(agents && { [sectionNames.agents]: agents }),
  };
}
